module.exports = __webpack_public_path__ + "static/media/CamVelo4.a27ad70b.png";